<template>
    <form-modal :value="modal" @input="close"
        :title="comment.title"
        size="lg"
        :centered="false"
    >
        <form @submit.prevent="submit">
            <base-input :label="$t('dashboard.general-comment')">
                <textarea class="form-control"
                    :placeholder="$t('dashboard.enter-comment-here')"
                    rows="10"
                    v-model="content"
                >

                </textarea>
            </base-input>

            <div class="text-center">

                <base-button type="primary" @click.prevent="submit" :loading="recording">
                    {{ $t('common.save') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="close">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </form-modal>
</template>

<script>
    export default {
        
        model: {
            prop: 'modal',
            event: 'input'
        },
        
        props: {

            modal: {
                type: Object,
                required: true
            },

            comment: {
                type: Object,
                required: true
            },

            endpoint: {
                type: String,
                required: true
            }
        },

        data() {

            return {
                recording: false,
                content: ''
            }
        },

        watch: {
            modal(val) {
                if (val.show) {
                    // The modal has just been opened. (Re)initialize the content.
                    this.content = this.comment.content
                }
            }
        },

        methods: {

            submit() {
                this.recording = true
                axios.post(this.endpoint, { comment: this.content })
                    .then(resp => {
                        this.recording = false
                        this.close()
                        this.$emit('change')
                    })
                    .catch(err => {
                        this.$auth.handleErrorVm(err, this)
                    })        
            },

            close() {
                this.$emit('input', {
                    show: false,
                })
            }
        }
    }
</script>